import { Product, ProductOption } from '../types/types'

export const CATEGORIES = [
  'Pizzas',
  'Bebidas',
  'Entradas',
  'Ensaladas',
  'Sopas',
  'A la Parrilla',
  'Arroz',
  'Pastas',
  'Otros',
  'Postres',
  'Sandwich',
  'Adicionales',
]

// Ingredient images for visual builder
export const INGREDIENT_IMAGES: Record<string, string> = {
  // Bases
  b1: 'https://images.unsplash.com/photo-1612929633738-8fe44f7ec841?w=200&h=200&fit=crop', // rice noodles
  b2: 'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=200&h=200&fit=crop', // white rice
  b3: 'https://images.unsplash.com/photo-1622206151226-18ca2c9ab4a1?w=200&h=200&fit=crop', // lettuce
  b4: 'https://images.unsplash.com/photo-1586201375761-83865001e31c?w=200&h=200&fit=crop', // quinoa
  b5: 'https://images.unsplash.com/photo-1551462147-ff29053bfc14?w=200&h=200&fit=crop', // pasta
  b6: 'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=200&h=200&fit=crop', // mixed greens
  // Proteinas
  p1: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=200&h=200&fit=crop', // salmon
  p2: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=200&h=200&fit=crop', // tuna
  p3: 'https://images.unsplash.com/photo-1565680018434-b513d5e5fd47?w=200&h=200&fit=crop', // shrimp
  p4: 'https://images.unsplash.com/photo-1604503468506-a8da13d82571?w=200&h=200&fit=crop', // chicken
  // Toppings
  t1: 'https://images.unsplash.com/photo-1504545102780-26774c1bb073?w=200&h=200&fit=crop', // mushrooms
  t2: 'https://images.unsplash.com/photo-1482049016688-2d3e1b311543?w=200&h=200&fit=crop', // boiled egg
  t3: 'https://images.unsplash.com/photo-1580201092675-a0a6a6cafbb1?w=200&h=200&fit=crop', // crispy onion
  t4: 'https://images.unsplash.com/photo-1551754655-cd27e38d2076?w=200&h=200&fit=crop', // corn
  t5: 'https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=200&h=200&fit=crop', // red onion
  t6: 'https://images.unsplash.com/photo-1546470427-0d4db154ceb8?w=200&h=200&fit=crop', // cherry tomato
  t7: 'https://images.unsplash.com/photo-1551462147-37885acc36f1?w=200&h=200&fit=crop', // black beans
  t8: 'https://images.unsplash.com/photo-1563565375-f3fdfdbefa83?w=200&h=200&fit=crop', // bell pepper
  t9: 'https://images.unsplash.com/photo-1515543904413-63f5ce37e990?w=200&h=200&fit=crop', // chickpeas
  t10: 'https://images.unsplash.com/photo-1598170845058-32b9d6a5da37?w=200&h=200&fit=crop', // carrot
  t11: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=200&h=200&fit=crop', // plantain
  t12: 'https://images.unsplash.com/photo-1583119022894-919a68a3d0e3?w=200&h=200&fit=crop', // scallion
  t13: 'https://images.unsplash.com/photo-1449300079323-02e209d9d3a6?w=200&h=200&fit=crop', // cucumber
  t14: 'https://images.unsplash.com/photo-1615485290382-441e4d049cb5?w=200&h=200&fit=crop', // hearts of palm
  t15: 'https://images.unsplash.com/photo-1553279768-865429fa0078?w=200&h=200&fit=crop', // mango
  t16: 'https://images.unsplash.com/photo-1464965911861-746a04b4bca6?w=200&h=200&fit=crop', // strawberry
  t17: 'https://images.unsplash.com/photo-1550258987-190a2d41a8ba?w=200&h=200&fit=crop', // pineapple
  t18: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=200&h=200&fit=crop', // croutons
  // Premium
  tp1: 'https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=200&h=200&fit=crop', // avocado
  tp2: 'https://images.unsplash.com/photo-1604977042946-1eecc30f269e?w=200&h=200&fit=crop', // pickles
  tp3: 'https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?w=200&h=200&fit=crop', // mozzarella
  tp4: 'https://images.unsplash.com/photo-1564894809611-1742fc40ed80?w=200&h=200&fit=crop', // edamame
  tp5: 'https://images.unsplash.com/photo-1504545102780-26774c1bb073?w=200&h=200&fit=crop', // mushrooms natural
  // Aderezos
  a1: 'https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=200&h=200&fit=crop', // house dressing
  a2: 'https://images.unsplash.com/photo-1541014741259-de529411b96a?w=200&h=200&fit=crop', // balsamic
  a3: 'https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=200&h=200&fit=crop', // ranch
  a4: 'https://images.unsplash.com/photo-1528750717929-32abb73d3bd9?w=200&h=200&fit=crop', // honey mustard
  a5: 'https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=200&h=200&fit=crop', // olive oil
  // Semillas
  s1: 'https://images.unsplash.com/photo-1508061253366-f7da158b6d46?w=200&h=200&fit=crop', // sesame
  s2: 'https://images.unsplash.com/photo-1514994667787-b48ca37155f0?w=200&h=200&fit=crop', // mixed seeds
}

export const BOWL_OPTIONS: Record<string, ProductOption[]> = {
  bases: [
    { id: 'b1', name: 'Fideos de arroz', price: 1000 },
    { id: 'b2', name: 'Arroz blanco', price: 600 },
    { id: 'b3', name: 'Lechuga', price: 350 },
    { id: 'b4', name: 'Quinoa', price: 700 },
    { id: 'b5', name: 'Pasta tipo pluma de garbanzos', price: 700 },
    { id: 'b6', name: 'Mix de hojas verdes', price: 700 },
  ],
  proteinas: [
    { id: 'p1', name: 'Salmón', price: 2000 },
    { id: 'p2', name: 'Atún', price: 1800 },
    { id: 'p3', name: 'Camarón', price: 2000 },
    { id: 'p4', name: 'Pollo', price: 1200 },
  ],
  toppings: [
    { id: 't1', name: 'Hongos (tarro)', price: 400 },
    { id: 't2', name: 'Huevo duro', price: 400 },
    { id: 't3', name: 'Cebolla crujiente', price: 400 },
    { id: 't4', name: 'Maíz dulce', price: 400 },
    { id: 't5', name: 'Cebolla morada', price: 400 },
    { id: 't6', name: 'Tomate cherry', price: 400 },
    { id: 't7', name: 'Frijoles negros', price: 400 },
    { id: 't8', name: 'Chile dulce', price: 400 },
    { id: 't9', name: 'Garbanzo', price: 400 },
    { id: 't10', name: 'Zanahoria', price: 400 },
    { id: 't11', name: 'Plátano maduro', price: 400 },
    { id: 't12', name: 'Cebollín', price: 400 },
    { id: 't13', name: 'Pepino', price: 400 },
    { id: 't14', name: 'Palmito', price: 400 },
    { id: 't15', name: 'Mango', price: 400 },
    { id: 't16', name: 'Fresa', price: 400 },
    { id: 't17', name: 'Piña', price: 400 },
    { id: 't18', name: 'Crutones', price: 400 },
  ],
  toppingsPremium: [
    { id: 'tp1', name: 'Aguacate', price: 700 },
    { id: 'tp2', name: 'Pepinillos', price: 700 },
    { id: 'tp3', name: 'Queso mozzarella', price: 700 },
    { id: 'tp4', name: 'Edamames', price: 700 },
    { id: 'tp5', name: 'Hongos naturales', price: 700 },
  ],
  aderezos: [
    { id: 'a1', name: 'Aderezo de la casa', price: 200 },
    { id: 'a2', name: 'Vinagreta balsámica', price: 200 },
    { id: 'a3', name: 'Ranch', price: 200 },
    { id: 'a4', name: 'Mostaza miel', price: 200 },
    { id: 'a5', name: 'Aceite de oliva y limón', price: 200 },
  ],
  semillas: [
    { id: 's1', name: 'Ajonjolí', price: 200 },
    { id: 's2', name: 'Semillas varias', price: 200 },
  ],
}

export const PIZZA_OPTIONS = {
  sizes: [
    { id: 'sz1', name: 'Personal', slices: '4 slices', price: 5500 },
    { id: 'sz2', name: 'Mediana', slices: '6 slices', price: 8500 },
    { id: 'sz3', name: 'Grande', slices: '8 slices', price: 9500 },
    { id: 'sz4', name: 'Super', slices: '12 slices', price: 10500 },
  ],
  sauces: [
    { id: 'sc1', name: 'Salsa de tomate', price: 0 },
    { id: 'sc2', name: 'Salsa blanca', price: 0 },
    { id: 'sc3', name: 'Salsa BBQ', price: 0 },
  ],
  toppingCategories: [
    {
      id: 'cat_carnes',
      name: 'Carnes',
      items: [
        { id: 'pt_jamon', name: 'Jamón', price: 800 },
        { id: 'pt_salami', name: 'Salami', price: 800 },
        { id: 'pt_pepperoni', name: 'Pepperoni', price: 800 },
        { id: 'pt_carne_molida', name: 'Carne molida', price: 800 },
        { id: 'pt_tocineta', name: 'Tocineta', price: 800 },
        { id: 'pt_pierna_cerdo', name: 'Pierna de cerdo', price: 800 },
        { id: 'pt_salchicha_italiana', name: 'Salchicha italiana', price: 800 },
        { id: 'pt_pollo', name: 'Pollo', price: 800 },
        { id: 'pt_pollo_bbq', name: 'Pollo BBQ', price: 800 },
      ],
    },
    {
      id: 'cat_mariscos',
      name: 'Mariscos',
      items: [
        { id: 'pt_camarones', name: 'Camarones', price: 1200 },
        { id: 'pt_mariscos_mixtos', name: 'Mariscos mixtos', price: 1200 },
      ],
    },
    {
      id: 'cat_vegetales',
      name: 'Vegetales',
      items: [
        { id: 'pt_chile_dulce', name: 'Chile dulce', price: 500 },
        { id: 'pt_cebolla', name: 'Cebolla', price: 500 },
        { id: 'pt_hongos', name: 'Hongos', price: 500 },
        { id: 'pt_tomate', name: 'Tomate', price: 500 },
        { id: 'pt_brocoli', name: 'Brócoli', price: 500 },
        { id: 'pt_jalapeno', name: 'Jalapeño', price: 500 },
        { id: 'pt_aceitunas', name: 'Aceitunas', price: 500 },
        { id: 'pt_pina', name: 'Piña', price: 500 },
        { id: 'pt_maiz_dulce', name: 'Maíz dulce', price: 500 },
      ],
    },
    {
      id: 'cat_quesos',
      name: 'Quesos',
      items: [
        { id: 'pt_extra_mozzarella', name: 'Extra mozzarella', price: 700 },
        { id: 'pt_queso_cheddar', name: 'Queso cheddar', price: 700 },
        { id: 'pt_queso_ricotta', name: 'Queso ricotta', price: 700 },
        { id: 'pt_queso_provolone', name: 'Queso provolone', price: 700 },
      ],
    },
    {
      id: 'cat_extras',
      name: 'Extras',
      items: [
        { id: 'pt_guacamole', name: 'Guacamole', price: 500 },
        { id: 'pt_huevo', name: 'Huevo', price: 500 },
      ],
    },
  ],
}

export const MENU_PRODUCTS: Product[] = [
  // PIZZAS
  {
    id: 'piz_emilius',
    name: 'Emilius',
    description:
      'Jamón, salami, pepperoni, carne molida, chile dulce, cebolla, hongos',
    price: 6500,
    category: 'Pizzas',
    subcategory: 'De Carnes',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10500 },
      { name: 'Grande', slices: '8 slices', price: 11000 },
      { name: 'Super', slices: '12 slices', price: 11500 },
    ],
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_chicago',
    name: 'Estilo Chicago',
    description: 'Jamón, salami, pepperoni, tocineta',
    price: 15000,
    category: 'Pizzas',
    subcategory: 'Especialidades',
    type: 'pizza',
    sizes: [{ name: 'Grande', slices: '8 slices', price: 15000 }],
    image:
      'https://images.unsplash.com/photo-1534308983496-4fabb1a015ee?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_meat_lovers',
    name: "Meat lover's",
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_pepperoni',
    name: 'Pepperoni',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_pierna_cerdo',
    name: 'Pierna de cerdo',
    description: 'Opcional BBQ',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_camarones',
    name: 'Con camarones',
    price: 9000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 9000 },
      { name: 'Mediana', slices: '6 slices', price: 13500 },
      { name: 'Grande', slices: '8 slices', price: 14500 },
      { name: 'Super', slices: '12 slices', price: 15500 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_cuatro_quesos',
    name: 'Cuatro quesos',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10500 },
      { name: 'Grande', slices: '8 slices', price: 11000 },
      { name: 'Super', slices: '12 slices', price: 11500 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_mariscos',
    name: 'Con mariscos',
    price: 10000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 10000 },
      { name: 'Mediana', slices: '6 slices', price: 14500 },
      { name: 'Grande', slices: '8 slices', price: 15500 },
      { name: 'Super', slices: '12 slices', price: 16500 },
    ],
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_cesar',
    name: 'Cesar',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_queso_ricotta',
    name: 'Queso ricotta',
    description: 'Con tomate o brócoli',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_margarita',
    name: 'Margarita',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_brasilena',
    name: 'Brasileña',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
    ],
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_chiniadita',
    name: 'Chiniadita',
    price: 11500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Mediana', slices: '6 slices', price: 11500 },
      { name: 'Grande', slices: '8 slices', price: 12500 },
      { name: 'Super', slices: '12 slices', price: 13500 },
    ],
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_pollo',
    name: 'Pollo',
    description: 'BBQ, buffalo',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 10500 },
      { name: 'Grande', slices: '8 slices', price: 11000 },
      { name: 'Super', slices: '12 slices', price: 11500 },
    ],
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_salchicha_italiana',
    name: 'Salchicha italiana',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_tocineta',
    name: 'Tocineta',
    description: 'Opcional salsa BBQ',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_hawaiana',
    name: 'Hawaiana',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_vegetariana',
    name: 'Vegetariana',
    price: 6500,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 6500 },
      { name: 'Mediana', slices: '6 slices', price: 10000 },
      { name: 'Grande', slices: '8 slices', price: 10500 },
      { name: 'Super', slices: '12 slices', price: 11000 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_primavera',
    name: 'Primavera',
    description: 'Brócoli, tomate, pollo a la parrilla',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 10500 },
      { name: 'Grande', slices: '8 slices', price: 11000 },
      { name: 'Super', slices: '12 slices', price: 11500 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_filet_pollo_lomito',
    name: 'Filet de pollo y lomito',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 10500 },
      { name: 'Grande', slices: '8 slices', price: 11500 },
      { name: 'Super', slices: '12 slices', price: 12500 },
    ],
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_mexicana',
    name: 'Mexicana',
    description:
      'Carne mechada, guacamole, jalapeño, tomate, queso cheddar y mozarella',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', slices: '4 slices', price: 7000 },
      { name: 'Mediana', slices: '6 slices', price: 11000 },
      { name: 'Grande', slices: '8 slices', price: 11500 },
      { name: 'Super', slices: '12 slices', price: 12000 },
    ],
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_extra_queso',
    name: 'Extra queso',
    price: 1300,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: 'Personal', price: 1300 },
      { name: 'Mediana', price: 1500 },
      { name: 'Grande', price: 1800 },
      { name: 'Super', price: 2000 },
    ],
    image:
      'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_slice_jamon',
    name: 'Slice jamón',
    price: 1300,
    category: 'Pizzas',
    type: 'pizza',
    image:
      'https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_slice_emilius',
    name: 'Slice Emilius',
    price: 1500,
    category: 'Pizzas',
    type: 'pizza',
    image:
      'https://images.unsplash.com/photo-1571407970349-bc81e7e96d47?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_siciliana',
    name: 'Siciliana (16 Slices)',
    price: 12000,
    category: 'Pizzas',
    type: 'pizza',
    sizes: [
      { name: '1 Ingrediente', price: 12000 },
      { name: '4 Estaciones', price: 13500 },
      { name: 'Emilius', price: 13500 },
    ],
    image:
      'https://images.unsplash.com/photo-1534308983496-4fabb1a015ee?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_calzone_jamon',
    name: 'Calzone jamón',
    price: 6000,
    category: 'Pizzas',
    type: 'pizza',
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_calzone_pollo_lomito',
    name: 'Calzone de pollo y lomito',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    image:
      'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_stromboli_sencillo',
    name: 'Stromboli sencillo',
    price: 7000,
    category: 'Pizzas',
    type: 'pizza',
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },
  {
    id: 'piz_stromboli_emilius',
    name: 'Stromboli Emilius',
    price: 8000,
    category: 'Pizzas',
    type: 'pizza',
    image:
      'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
  },

  // BEBIDAS
  {
    id: 'beb_cal_chocolate',
    name: 'Chocolate',
    price: 800,
    category: 'Bebidas',
    subcategory: 'Calientes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1542990253-0d0f5be5f0ed?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_cal_cafe',
    name: 'Café de Los Santos',
    price: 1200,
    category: 'Bebidas',
    subcategory: 'Calientes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_cal_te',
    name: 'Té',
    price: 700,
    category: 'Bebidas',
    subcategory: 'Calientes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_cal_aguadulce',
    name: 'Agua dulce',
    price: 700,
    category: 'Bebidas',
    subcategory: 'Calientes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1544787219-7f47ccb76574?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_frappe_taro',
    name: 'Frappé Taro',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Frappé',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553787762-b5f5721f3270?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_frappe_mocha',
    name: 'Frappé Mocha',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Frappé',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553787762-b5f5721f3270?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_frappe_chicle',
    name: 'Frappé Chicle',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Frappé',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553787762-b5f5721f3270?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_frappe_caramelo',
    name: 'Frappé Caramelo Latte',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Frappé',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553787762-b5f5721f3270?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_frappe_melon',
    name: 'Frappé Melón verde',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Frappé',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553787762-b5f5721f3270?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_frappe_algodon',
    name: 'Frappé Algodón de azúcar',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Frappé',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1553787762-b5f5721f3270?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_emilius',
    name: 'Batido Premium Emilius',
    description: 'Helado, papaya, fresa, coco y leche',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_oreo',
    name: 'Batido Premium Oreo',
    description: 'Helado, galletas y leche',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_master',
    name: 'Batido Premium Master shake',
    description: 'Melocotón, mango, helado y jugo de naranja',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_cocles',
    name: 'Batido Premium Playa Cocles',
    description: 'Helado, limón, coco y leche',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_pirata',
    name: 'Batido Premium Pirata rojo',
    description: 'Sandía, uvas rojas y kiwi',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_pina',
    name: 'Batido Premium Piña colada',
    description: 'Piña, crema de coco y naranja',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_bat_santos',
    name: 'Batido Premium Los Santos',
    description: 'Café, helado, chocolate, vainilla y leche',
    price: 2200,
    category: 'Bebidas',
    subcategory: 'Batidos Premium',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_milkshake',
    name: 'Milkshake o Combinado',
    description:
      '2 Frutas a elegir: Melón, Mora, Fresa, Sandía, Piña, Papaya, Mango, Limón, Melocotón, Guanábana',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Milkshakes',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1505252585461-04db1eb84625?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_cerveza_pichel',
    name: 'Cerveza Cruda - Pichel',
    price: 6500,
    category: 'Bebidas',
    subcategory: 'Cerveza Cruda',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1535958636474-b021ee887b13?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_cerveza_jarra',
    name: 'Cerveza Cruda - Jarra 600ml',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Cerveza Cruda',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1535958636474-b021ee887b13?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_refresco_dia',
    name: 'Refresco del día',
    price: 1100,
    category: 'Bebidas',
    subcategory: 'Refrescos',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1497534446932-c925b458314e?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_gaseosas',
    name: 'Gaseosas y Tropicales',
    price: 1500,
    category: 'Bebidas',
    subcategory: 'Gaseosas y Tropicales',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1527960471264-932f39eb5846?w=400&h=300&fit=crop',
  },
  {
    id: 'beb_licores',
    name: 'Cervezas y Licores Nacionales y Extranjeros',
    price: 2000,
    category: 'Bebidas',
    subcategory: 'Cervezas y Licores',
    type: 'bebida',
    image:
      'https://images.unsplash.com/photo-1535958636474-b021ee887b13?w=400&h=300&fit=crop',
  },

  // ENTRADAS
  {
    id: 'ent_calamar',
    name: 'Calamar frito',
    price: 4500,
    category: 'Entradas',
    type: 'entrada',
    image:
      'https://images.unsplash.com/photo-1604909052743-94e838986d24?w=400&h=300&fit=crop',
  },
  {
    id: 'ent_alitas',
    name: 'Alitas',
    description: 'BBQ, agridulce, picante, ranch',
    price: 3000,
    category: 'Entradas',
    type: 'entrada',
    image:
      'https://images.unsplash.com/photo-1527477396000-e27163b60e69?w=400&h=300&fit=crop',
  },
  {
    id: 'ent_papas',
    name: 'Papas a la francesa',
    price: 2000,
    category: 'Entradas',
    type: 'entrada',
    image:
      'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?w=400&h=300&fit=crop',
  },
  {
    id: 'ent_pan_ajo',
    name: 'Orden de pan con ajo',
    price: 2000,
    category: 'Entradas',
    type: 'entrada',
    image:
      'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=400&h=300&fit=crop',
  },
  {
    id: 'ent_ceviche',
    name: 'Ceviche',
    description: 'Disponible según el día',
    price: 3500,
    category: 'Entradas',
    type: 'entrada',
    image:
      'https://images.unsplash.com/photo-1535399831218-d5bd36d1a6b3?w=400&h=300&fit=crop',
  },

  // ENSALADAS
  {
    id: 'ens_cesar',
    name: 'Ensalada cesar',
    description: 'Con pollo',
    price: 6000,
    category: 'Ensaladas',
    type: 'ensalada',
    image:
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=300&fit=crop',
  },
  {
    id: 'ens_verde',
    name: 'Ensalada Verde',
    price: 4000,
    category: 'Ensaladas',
    type: 'ensalada',
    image:
      'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=400&h=300&fit=crop',
  },
  {
    id: 'ens_camarones',
    name: 'Ensalada con camarones',
    price: 6000,
    category: 'Ensaladas',
    type: 'ensalada',
    image:
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=300&fit=crop',
  },
  {
    id: 'ens_mixta',
    name: 'Ensalada Mixta',
    price: 6000,
    category: 'Ensaladas',
    type: 'ensalada',
    image:
      'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=400&h=300&fit=crop',
  },

  // SOPAS
  {
    id: 'sop_pollo',
    name: 'Sopa de Pollo',
    price: 4500,
    category: 'Sopas',
    type: 'sopa',
    image:
      'https://images.unsplash.com/photo-1603105037880-880cd4edfb0d?w=400&h=300&fit=crop',
  },
  {
    id: 'sop_mariscos',
    name: 'Sopa de Mariscos',
    description: 'En agua o en leche',
    price: 6000,
    category: 'Sopas',
    type: 'sopa',
    image:
      'https://images.unsplash.com/photo-1594756202469-9ff9799b2e4e?w=400&h=300&fit=crop',
  },
  {
    id: 'sop_azteca',
    name: 'Sopa Azteca',
    price: 5000,
    category: 'Sopas',
    type: 'sopa',
    image:
      'https://images.unsplash.com/photo-1476718406336-bb5a9690ee2a?w=400&h=300&fit=crop',
  },

  // A LA PARRILLA
  {
    id: 'par_lomito_emilius',
    name: 'Lomito Emilius',
    description: 'En salsa de hongos, queso povolone, chile pimentón',
    price: 9500,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_lomito_caballo',
    name: 'Lomito a caballo',
    description: 'Sobre cama de mariscos',
    price: 10000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_lomito_medallones',
    name: 'Lomito en medallones',
    price: 8500,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_hamburguesa',
    name: 'Hamburguesa Emilius',
    description: 'Angus Choice (Torta de Carne 350g)',
    price: 5000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&h=300&fit=crop',
  },
  {
    id: 'par_churrasco',
    name: 'Churrasco',
    description: 'Angus Choice',
    price: 10000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_new_york',
    name: 'New York Steak',
    description: 'Angus Choice',
    price: 10000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_diezmillo',
    name: 'Diezmillo',
    description: 'Angus Choice',
    price: 15000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_entrana',
    name: 'Entraña',
    description: 'Angus Choice',
    price: 10000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_rib_eye',
    name: 'Rib Eye',
    description: 'Angus Choice',
    price: 10000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_chuleton',
    name: 'Chuletón Emilius',
    price: 8000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'par_salmon',
    name: 'Salmón',
    price: 7000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=300&fit=crop',
  },
  {
    id: 'par_filet_pollo',
    name: 'Filet de pollo',
    price: 7000,
    category: 'A la Parrilla',
    type: 'parrilla',
    note: 'Incluye dos acompañamientos a elegir entre: Arroz, papas fritas o en gajos, ensalada, vegetales o puré. Cada acompañamiento adicional tiene un valor de ₡1000',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },

  // ARROZ
  {
    id: 'arr_emilius',
    name: 'Emilius',
    description: 'Mariscos, pollo y lomito',
    price: 8000,
    category: 'Arroz',
    type: 'arroz',
    note: 'Acompañados de papas campesinas en gajos y ensalada verde.',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'arr_camarones',
    name: 'Con camarones',
    price: 7000,
    category: 'Arroz',
    type: 'arroz',
    note: 'Acompañados de papas campesinas en gajos y ensalada verde.',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'arr_cantones',
    name: 'Cantonés',
    price: 6000,
    category: 'Arroz',
    type: 'arroz',
    note: 'Acompañados de papas campesinas en gajos y ensalada verde.',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'arr_cantones_camaron',
    name: 'Cantonés con camarón',
    price: 7000,
    category: 'Arroz',
    type: 'arroz',
    note: 'Acompañados de papas campesinas en gajos y ensalada verde.',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'arr_cerdo',
    name: 'Con cerdo',
    price: 6000,
    category: 'Arroz',
    type: 'arroz',
    note: 'Acompañados de papas campesinas en gajos y ensalada verde.',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'arr_mariscos',
    name: 'Mariscos',
    price: 7000,
    category: 'Arroz',
    type: 'arroz',
    note: 'Acompañados de papas campesinas en gajos y ensalada verde.',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },

  // PASTAS
  {
    id: 'pas_emilius',
    name: 'Emilius',
    description: 'Con mariscos / salsa blanca o roja',
    price: 7000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_lasana',
    name: 'Lasaña',
    description: 'Carne o pollo / salsa blanca o roja',
    price: 6000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1574894709920-11de28b71886?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_jamon_mantequilla',
    name: 'Jamón y mantequilla',
    price: 5000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_crema_pollo',
    name: 'Crema blanca con pollo',
    price: 6000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_camarones',
    name: 'Con camarones',
    description: 'Salsa blanca o roja',
    price: 7000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_bolognesa',
    name: 'A la bolognesa',
    price: 6000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_penne_vodka_pollo',
    name: 'Penne al Vodka con pollo',
    price: 6500,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_penne_vodka_camarones',
    name: 'Penne al Vodka con camarones',
    price: 7000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_pesto_pollo',
    name: 'Pesto con pollo',
    price: 6500,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },
  {
    id: 'pas_pesto_camarones',
    name: 'Pesto con camarones',
    price: 7000,
    category: 'Pastas',
    type: 'pasta',
    note: 'Acompañadas de pan con ajo.',
    image:
      'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?w=400&h=300&fit=crop',
  },

  // OTROS
  {
    id: 'otr_cordon_bleu',
    name: 'Cordon bleu',
    price: 6000,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_cordon_bleu_blanca',
    name: 'Cordon bleu en salsa blanca',
    price: 6500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_fajitas_emilius',
    name: 'Fajitas Emilius al sartén',
    price: 6500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_trucha',
    name: 'Trucha entera empanizada',
    price: 6500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_pollo_parmesano',
    name: 'Pollo Parmesano',
    description: 'Salsa blanca o roja',
    price: 6500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_pollo_frances',
    name: 'Pollo Francés',
    price: 6500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_filet_pescado_empanizado',
    name: 'Filet de Pescado',
    description: 'Empanizado',
    price: 6000,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_filet_pescado_ajillo',
    name: 'Filet de Pescado',
    description: 'Al ajillo o francés',
    price: 6500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_pollo_marsalla',
    name: 'Pollo Marsalla',
    price: 7000,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_fajitas_pollo',
    name: 'Fajitas de pollo',
    description: 'Empanizadas',
    price: 5500,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_pollo_scampi',
    name: 'Pollo Scampi',
    price: 7000,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1532550907401-a500c9a57435?w=400&h=300&fit=crop',
  },
  {
    id: 'otr_pescado_scampi',
    name: 'Pescado Scampi',
    price: 7000,
    category: 'Otros',
    type: 'otro',
    note: 'Consulte por los acompañamientos de cada platillo.',
    image:
      'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=300&fit=crop',
  },

  // POSTRES
  {
    id: 'pos_pizza_fresa',
    name: 'Pizza de Fresa con Nutella',
    description: 'Pizza con fruta base de Nutella',
    price: 5500,
    category: 'Postres',
    type: 'postre',
    sizes: [
      { name: 'Pequeña', price: 5500 },
      { name: 'Grande', price: 7000 },
    ],
    image:
      'https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=300&fit=crop',
  },
  {
    id: 'pos_pizza_melocoton',
    name: 'Pizza de Melocotón con Nutella',
    description: 'Pizza con fruta base de Nutella',
    price: 5500,
    category: 'Postres',
    type: 'postre',
    sizes: [
      { name: 'Pequeña', price: 5500 },
      { name: 'Grande', price: 7000 },
    ],
    image:
      'https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=300&fit=crop',
  },
  {
    id: 'pos_pizza_pina',
    name: 'Pizza de Piña con Nutella',
    description: 'Pizza con fruta base de Nutella',
    price: 5500,
    category: 'Postres',
    type: 'postre',
    sizes: [
      { name: 'Pequeña', price: 5500 },
      { name: 'Grande', price: 7000 },
    ],
    image:
      'https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=300&fit=crop',
  },
  {
    id: 'pos_postre_dia',
    name: 'Postre del día',
    price: 2000,
    category: 'Postres',
    type: 'postre',
    image:
      'https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=300&fit=crop',
  },
  {
    id: 'pos_vaca_negra',
    name: 'Vaca negra',
    description: 'Coca cola o root beer con helado de vainilla',
    price: 1400,
    category: 'Postres',
    type: 'postre',
    image:
      'https://images.unsplash.com/photo-1551024601-bec78aea704b?w=400&h=300&fit=crop',
  },

  // SANDWICH
  {
    id: 'san_lomito',
    name: 'Lomito especial (Cheesesteak)',
    description: 'Chile, cebolla, hongos y queso americano',
    price: 6000,
    category: 'Sandwich',
    type: 'sandwich',
    image:
      'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400&h=300&fit=crop',
  },
  {
    id: 'san_italiano',
    name: 'Italiano',
    price: 5000,
    category: 'Sandwich',
    type: 'sandwich',
    image:
      'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?w=400&h=300&fit=crop',
  },

  // ADICIONALES
  {
    id: 'adi_arroz',
    name: 'Arroz blanco',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_ensalada',
    name: 'Ensalada verde',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_vegetales',
    name: 'Vegetales',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1540420773420-3366772f4999?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_papas',
    name: 'Papas a la francesa',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_pure',
    name: 'Puré de papa',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1536304929831-ee1ca9d44906?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_pan_ajo',
    name: 'Pan con ajo',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1509440159596-0249088772ff?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_papas_campesinas',
    name: 'Papas campesinas en gajos',
    price: 1000,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?w=400&h=300&fit=crop',
  },
  {
    id: 'adi_salsas',
    name: 'Salsas o aderezos adicionales',
    price: 250,
    category: 'Adicionales',
    type: 'adicional',
    image:
      'https://images.unsplash.com/photo-1472476443507-c7a5948772fc?w=400&h=300&fit=crop',
  },
]
